import React, {Fragment} from 'react';

// import PropTypes from 'prop-types';

class Default extends React.Component {

  state = {};

  render() {
    return (
      <Fragment>
        <h3>Page Not Found!</h3>
      </Fragment>
    );
  }
}

// Default.propTypes = {};

export default Default;
